import React , { Component } from 'react'
import { IndexLink, Link, browserHistory } from 'react-router'
import { autoLogin, checkIfLoggedIn } from 'store/auth'

import localForage from 'localforage'
import dates from 'helpers/dates'
import delay from 'helpers/delay'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Toolbar from '@material-ui/core/Toolbar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'


import Notification from 'components/Notification'

import Times2Logo from 'styles/logo/times2-logo.svg'

import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import InfoOutlineIcon from '@material-ui/icons/InfoOutline'


const TabContainer = props =>
	<div style={{padding: '64px 0 0', height: '100vh'}}>
		{props.children}
	</div>;

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
}

const styleSheet = theme => ({
	root: {
		flexGrow: 1,
		height: '1vh'
	},
	header: {
		display: 'flex',
		flexDirection: 'row'
	},
	toolBar: {
		width: '100%',
		padding: '0'
	},
	tabs: {
		height: '64px'
	},
	logo: {
		width: 64,
		height:64
	},
	accountButton: {
		position: 'absolute',
		right: 64
	},
})

class PageLayout extends Component {

	state = {
		anchorEl: null,
		ready: false
	}

	constructor(props, context) {
		super(props, context)
		this.handleMenu = this.handleMenu.bind(this)
		this.handleClose = this.handleClose.bind(this)
		this.dispatchLogout = this.dispatchLogout.bind(this)
		this.props.location.state = {
			index: 0,
		}
	}

	// Array with routes, there must be a better way to do this but for now it works
	routes = [
		'/home/',
		'/edit/',
		'/preview/',
		'/output/'
	]

	componentDidMount(){
		localForage.getItem('times2User')
		.then(value => {
			if(value){
				let user = JSON.parse(value)
				let val = new Date(user.validity)
				if(dates.compare(new Date(), val, dates) == -1){
					this.context.store.dispatch({
						type: 'AUTO_LOGIN',
						payload: user
					})
					this.setState({
						ready: true
					})
				} else {
					browserHistory.push({
						pathname: '/',
						state: {
							index: 0
						}
					})
					this.setState({
						ready: true
					})
				}
			} else {
				browserHistory.push({
					pathname: '/',
					state: {
						index: 0
					}
				})
				this.setState({
					ready: true
				})
			}
		})
		.catch(error => console.log(error))
	}

	handleTabChange = (event, index) => {
		browserHistory.push({
			pathname: this.routes[index],
			state: {
				index: index
			}
		})
	}

	handleMenu = event => {
		this.setState({ anchorEl: event.currentTarget })
	}

	handleClose() {
		this.setState({ anchorEl: null })
  	}

  	shouldComponentUpdate() {
  		return true
  	}

  	dispatchLogout() {
  		this.handleClose()
  		this.context.store.dispatch({
  			type: 'LOGOUT',
		})
		delay(500).then(() => {
			location.reload()
		})
  	}

	render() {
		const styles = this.props.classes
		const { anchorEl } = this.state
		const open = Boolean(anchorEl)
		if(this.state.ready) {
			return (
				<div style={{overflow: 'auto', height: '100%'}}>
					<AppBar position="fixed">
						<div className={styles.header}>
							<img src={Times2Logo} className={styles.logo}/>
							<Toolbar className={styles.toolBar}>
								<Tabs value={this.props.location.state.index} onChange={this.handleTabChange} className={styles.tabs}>
									<Tab value={0} label="Home" className={styles.tabs}/>
									<Tab value={1} label="Edit" className={styles.tabs}/>
									<Tab value={2} label="Preview" className={styles.tabs}/>
									<Tab value={4} label="Output" className={styles.tabs}/>
								</Tabs>
								<IconButton
									aria-owns={open ? 'menu-appbar' : null}
									aria-haspopup="true"
									onClick={this.handleMenu}
									color="inherit"
									className={styles.accountButton}
								>
									<AccountCircleIcon />
								</IconButton>
								<Menu
									id="menu-appbar"
									anchorEl={anchorEl}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									open={open}
									onClose={this.handleClose}
								>
									<MenuItem onClick={this.handleClose}>
										<ListItemIcon><InfoOutlineIcon /></ListItemIcon>
										<ListItemText inset primary={AppVersion} />
									</MenuItem>
									<MenuItem onClick={this.dispatchLogout}>
										  <ListItemIcon>
											  <ExitToAppIcon />
										  </ListItemIcon>
										  <ListItemText inset primary="Log out" />
									  </MenuItem>
								</Menu>
							</Toolbar>
						</div>
					</AppBar>
					<TabContainer children={this.props.children} />
						<Notification store={this.context.store} notification={this.props.notifications.current} />
					</div>
			)
		} else {
			return (<div></div>)
		}
	}


}

PageLayout.contextTypes = {
	store: PropTypes.object.isRequired
}

PageLayout.propTypes = {
	children: PropTypes.node,
	classes: PropTypes.object.isRequired,
	store: PropTypes.object
}

const mapStateToProps = (state) => ({
	notifications: state.notifications
})

export default connect(mapStateToProps)(withStyles(styleSheet)(PageLayout))


// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js